import React from 'react';
import Button from '../../Button/Button';
import { useTranslation } from '../../../hooks/useTranslation';
import styles from '../Calculator.module.css';

interface StepSuccessProps {
    onClose: () => void;
}

const StepSuccess: React.FC<StepSuccessProps> = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.step}>
            <div className={styles.header}>
                <h3 className={styles.title}>{t('calculator.success.title')}</h3>
                <p className={styles.subtitle}>{t('calculator.success.message')}</p>
            </div>
            <Button variant="primary" onClick={onClose} className={styles.nextButton}>
                {t('calculator.success.return')}
            </Button>
        </div>
    );
};

export default StepSuccess;
